import { useState, useEffect } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { dataService } from '../services/dataService';

export const useAiAccess = () => {
  const { tenantData } = useAuth();
  const [hasAccess, setHasAccess] = useState<boolean>(false);
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const checkAccess = async () => {
      if (!tenantData?.id) {
        setHasAccess(false);
        setIsLoading(false);
        return;
      }

      try {
        setIsLoading(true);
        setError(null);
        const access = await dataService.hasAiChatbotAccess(tenantData.id);
        setHasAccess(access);
      } catch (err) {
        console.error('Error checking AI access:', err);
        setError('Failed to check AI access');
        setHasAccess(false);
      } finally {
        setIsLoading(false);
      }
    };

    checkAccess();
  }, [tenantData?.id]);

  return {
    hasAccess,
    isLoading,
    error,
    checkAccess: () => {
      if (tenantData?.id) {
        dataService.hasAiChatbotAccess(tenantData.id).then(setHasAccess);
      }
    }
  };
}; 